"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "plugin.keyclock.error.null": "Authentication error",
};
//# sourceMappingURL=messages.en-GB.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-keycloak/dist/messages/messages.en-GB.js
// module id = 2422
// module chunks = 0